import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "text-right align-self-end" }
const _hoisted_2 = {
  class: "btn-group mr-1",
  role: "group"
}
const _hoisted_3 = {
  title: "Enterprise Plan Settings",
  class: "btn btn-outline-secondary mr-1",
  style: {"padding":"0.7em 1em"}
}
const _hoisted_4 = {
  title: "Back to Enterprise Plans",
  class: "btn btn-outline-secondary",
  style: {"padding":"0.7em 1em"}
}

import { computed } from 'vue'
    import { useRoute } from 'vue-router'

    import SchedulerDialog from '@Quest/CorporateScenarios/Components/SchedulerDialog.vue'
    import { SchedulerDialogViewModel } from '@Quest/CorporateScenarios/Components/SchedulerDialog'
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ScenarioNavigation',
  emits: ["scheduled"],
  setup(__props, { emit: __emit }) {

    const emit = __emit
    
    // ---------------- router ----------------

    const route = useRoute()

    // ---------------- route-derived state ----------------

    const workspaceId = computed(() => Number(route.params?.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params?.strategyId ?? ''))
    const scenarioId = computed(() => String(route.params?.scenarioId ?? ''))

    // ---------------- local state ----------------

    // runtime instance → normal import
    const schedulerDialog = new SchedulerDialogViewModel()

    function showSchedulerDialog()
    {
        schedulerDialog.show()
    }


    // ---------------- helpers ----------------

    function getButtonClass(path: string): string
    {
        const routePrefix = `/enterprise-plan/${path}/`
        return route.path.startsWith(routePrefix)
            ? 'btn btn-secondary'
            : 'btn btn-outline-secondary'
    }

    function onScheduled(result: any) 
    {
        emit('scheduled', result)
    }


return (_ctx: any,_cache: any) => {
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SchedulerDialog, {
      viewModel: _unref(schedulerDialog),
      onScheduled: onScheduled
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        type: "button",
        title: "Open Scheduler (AI Assistant)",
        class: "btn btn-primary mr-1",
        style: {"padding":"0.7em 1em"},
        onClick: showSchedulerDialog
      }, [...(_cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "fa-solid fa-robot fa-lg mr-1" }, null, -1 /* CACHED */),
        _createTextVNode(" Scheduler ", -1 /* CACHED */)
      ]))]),
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createElementBlock("a", {
          title: "Portfolios",
          class: _normalizeClass(getButtonClass('portfolios')),
          style: {"padding":"0.7em 1em"}
        }, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "fa-solid fa-sitemap fa-lg" }, null, -1 /* CACHED */)
        ]))], 2 /* CLASS */)), [
          [_directive_sanitizedHref, `/#/enterprise-plan/portfolios/${workspaceId.value}/${strategyId.value}/${scenarioId.value}`]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", {
          title: "Projects",
          class: _normalizeClass(getButtonClass('projects')),
          style: {"padding":"0.7em 1em"}
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "fa-solid fa-table fa-lg" }, null, -1 /* CACHED */)
        ]))], 2 /* CLASS */)), [
          [_directive_sanitizedHref, `/#/enterprise-plan/projects/${workspaceId.value}/${strategyId.value}/${scenarioId.value}`]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", {
          title: "Schedule",
          class: _normalizeClass(getButtonClass('schedule')),
          style: {"padding":"0.7em 1em"}
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "fa-regular fa-calendar fa-lg" }, null, -1 /* CACHED */)
        ]))], 2 /* CLASS */)), [
          [_directive_sanitizedHref, `/#/enterprise-plan/schedule/${workspaceId.value}/${strategyId.value}/${scenarioId.value}`]
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("a", {
        title: "Profit & Loss Report",
        class: _normalizeClass(["mr-1", getButtonClass('pnl')]),
        style: {"padding":"0.7em 2em"}
      }, [...(_cache[4] || (_cache[4] = [
        _createTextVNode(" P&L ", -1 /* CACHED */)
      ]))], 2 /* CLASS */)), [
        [_directive_sanitizedHref, `/#/enterprise-plan/pnl/${workspaceId.value}/${strategyId.value}/${scenarioId.value}`]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_3, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("i", {
          class: "fa fa-lg fa-cog",
          "aria-hidden": "true"
        }, null, -1 /* CACHED */)
      ]))])), [
        [_directive_sanitizedHref, `/#/enterprise-plan/settings/${workspaceId.value}/${strategyId.value}/${scenarioId.value}`]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, [...(_cache[6] || (_cache[6] = [
        _createElementVNode("i", { class: "fa-solid fa-door-open fa-lg" }, null, -1 /* CACHED */)
      ]))])), [
        [_directive_sanitizedHref, `/#/enterprise/planning/${workspaceId.value}/${strategyId.value}`]
      ])
    ])
  ]))
}
}

})